import type { Funnel } from '../analyticsApi';
import { percent } from './format';

// Three ordered stages is ordinal, not categorical: one hue in monotone
// lightness steps. Validated against the white card surface — monotone L,
// adjacent gaps, single hue, light end at 2.24:1. Do not brighten it; #a8bfaa
// fails the contrast floor at 1.96:1.
const RAMP = ['#9db39f', '#7e957f', '#5c7a5e'];

export default function FunnelChart({ funnel }: { funnel: Funnel }) {
  const stages = [
    { label: 'Blog reads', value: funnel.article_views },
    { label: 'Clicked "Get in touch"', value: funnel.cta_clicks },
    { label: 'Sent an enquiry', value: funnel.contact_submits },
  ];
  const rates = [funnel.cta_rate, funnel.submit_rate];
  const max = Math.max(funnel.article_views, 1);

  return (
    <section className="rounded-2xl bg-white p-5 shadow-card">
      <h3 className="font-nunito text-sm text-ink-soft">Blog to enquiry</h3>

      <div className="mt-4 space-y-1">
        {stages.map((stage, i) => (
          <div key={stage.label}>
            <div className="flex items-center gap-3">
              <span className="w-44 shrink-0 font-nunito text-xs text-ink-soft">
                {stage.label}
              </span>
              <svg
                viewBox="0 0 400 28"
                className="h-7 flex-1"
                role="img"
                aria-label={`${stage.label}: ${stage.value}`}
              >
                <rect
                  x="0"
                  y="4"
                  width={Math.max((stage.value / max) * 400, 2)}
                  height="20"
                  rx="4"
                  fill={RAMP[i]}
                />
              </svg>
              <span className="w-12 shrink-0 text-right font-nunito text-sm font-semibold text-ink [font-variant-numeric:tabular-nums]">
                {stage.value}
              </span>
            </div>

            {i < rates.length && (
              <p className="ml-44 pl-3 font-nunito text-xs text-meta">
                {percent(rates[i])} continue
              </p>
            )}
          </div>
        ))}
      </div>

      <p className="mt-4 border-t border-hairline pt-3 font-nunito text-xs text-ink-soft">
        Overall: {percent(funnel.overall_rate)} of blog reads become an enquiry
      </p>
    </section>
  );
}
